import { config } from '../../../Configurations';

class Path {
    constructor() {
        this.host = `${config.baseUrl}/api`;
        this.varsionApi = 'v1';
    }
    get url() {
        return `${this.host}/${this.varsionApi}`;
    }
    logIn() {
        return `${this.url}/auth/login`;
    }
    loginFacebook() {
        return `${this.url}/auth/login/social`;
    }
    registerGymAccount() {
        return `${this.url}/auth/register?type=GYM`;
    }
    registerUserAccount() {
        return `${this.url}/auth/register`;
    }
    logOut() {
        return `${this.url}/auth/logout`;
    }

    deleteUserAccount() {
        return `${this.url}/settings/account/delete`;
    }

    // Users
    getAllUsers(filter, offset_id) {
        return offset_id && filter ? `${this.url}/users?filter=${filter}&offset_id=${offset_id}` : `${this.url}/users`;
    }

    getAllUsersForSearch(filter, offset_id, offset_followers) {
        if (filter && !offset_id && !offset_followers) {
            return `${this.url}/users?filter=${filter}`;
        }

        if (!filter && offset_id && offset_followers) {
            return `${this.url}/users?filter=&offset_id=${offset_id}&offset_followers=${offset_followers}`;
        }

        if (filter && offset_id && offset_followers) {
            return `${this.url}/users?filter=${filter}&offset_id=${offset_id}&offset_followers=${offset_followers}`;
        }

        if (filter && offset_id && !offset_followers) {
            return `${this.url}/users?filter=${filter}&offset_id=${offset_id}&offset_followers=${offset_followers}`;
        }

        return `${this.url}/users`;
    }

    getBookedUsers(workoutId) {
        return `${this.url}/workouts/${workoutId}/booked-users`;
    }

    createWorkoutUrlRequest(filter, offset_id) {
        if (filter && !offset_id) {
            return `${this.url}/workouts?filter=${filter}`;
        }

        if (!filter && offset_id) {
            return `${this.url}/workouts?filter=&offset_id=${offset_id}`;
        }

        if ((filter, offset_id)) {
            return `${this.url}/workouts?filter=${filter}&offset_id=${offset_id}`;
        }

        return `${this.url}/workouts`;
    }

    getUserInfo(user_id = '') {
        return user_id.length > 0 ? `${this.url}/profile?id=${user_id}` : `${this.url}/profile`;
    }

    // Workouts
    getAllActivites(user_id, offset_id, offset_date) {
        return offset_id && offset_date
            ? `${this.url}/profile/activity?id=${user_id}&offset_id=${offset_id}&offset_date=${offset_date}`
            : `${this.url}/profile/activity?id=${user_id}`;
    }

    getPlannedWorkouts(user_id, offset_id, offset_date) {
        if (offset_id && offset_date && user_id) {
            return `${this.url}/profile/planned?id=${user_id}&offset_id=${offset_id}&offset_date=${offset_date}`;
        } else if (offset_id && offset_date) {
            return `${this.url}/profile/planned?offset_id=${offset_id}&offset_date=${offset_date}`;
        }
        return `${this.url}/profile/planned`;
    }

    getBreakDownById(bd_id) {
        return `${this.url}/workouts/${bd_id}/breakdown`;
    }

    getCurrentWorkout(workoutId) {
        return `${this.url}/workouts/${workoutId}`;
    }

    getWorkoutStockImage(workoutType) {
        return `${this.url}/random-image?workout-type=${workoutType}`;
    }

    // Leaderboards
    getAllLeaderboards(user_id = '', pagination_offset) {
        const urlbase = `${this.url}/profile/leaderboards`;

        if (user_id.length > 0) {
            return pagination_offset
                ? `${urlbase}?id=${user_id}&offset_id=${pagination_offset}`
                : `${urlbase}?id=${user_id}`;
        } else {
            return pagination_offset ? `${urlbase}?offset_id=${pagination_offset}` : urlbase;
        }
    }

    getListOfLeaderboards(leaderboardId) {
        return `${this.url}/leaderboards/${leaderboardId}`;
    }

    getWorkoutLeaderboards(workoutId, pagination_offset) {
        return pagination_offset
            ? `${this.url}/workouts/${workoutId}/leaderboards?offset_id=${pagination_offset}`
            : `${this.url}/workouts/${workoutId}/leaderboards`;
    }

    // Password restoring
    forgotPassword() {
        return `${this.url}/auth/forgot-password`;
    }

    setPassword(hash) {
        return `${this.url}/auth/set-password?hash=${hash}`;
    }

    // Preferences
    getUserPreferences() {
        return `${this.url}/settings/preferences`;
    }

    // Followers
    getProfileFollowers(user_id) {
        return user_id ? `${this.url}/followers?id=${user_id}` : `${this.url}/followers`;
    }

    // Classes
    getProfileClasses(user_id, offset_id, offset_date) {
        return offset_id && offset_date
            ? `${this.url}/profile/classes?id=${user_id}&offset_id=${offset_id}&offset_date=${offset_date}`
            : `${this.url}/profile/classes?id=${user_id}`;
    }

    getClassesByDate(user_id, offset_id, offset_date, filter_date) {
        return offset_id && offset_date
            ? `${
                  this.url
              }/profile/classes?id=${user_id}&filter_date=${filter_date}&offset_id=${offset_id}&offset_date=${offset_date}`
            : `${this.url}/profile/classes?id=${user_id}&filter_date=${filter_date}`;
    }

    getClassesByDateRange(startDate, endDate) {
        return `${this.url}/classes/by-dates?start=${startDate}&end=${endDate}`;
    }

    createClass() {
        return `${this.url}/classes/new`;
    }

    updateClass(class_id) {
        return `${this.url}/classes/${class_id}/update`;
    }

    deleteClass(class_id) {
        return `${this.url}/classes/${class_id}/delete`;
    }

    updateClassSeries(series_id) {
        return `${this.url}/classes/series/${series_id}/update`;
    }

    deleteClassSeries(series_id) {
        return `${this.url}/classes/series/${series_id}/delete`;
    }

    getClassBookers(class_id) {
        return `${this.url}/classes/${class_id}/bookings`;
    }

    getClassMembers(class_id) {
        return `${this.url}/classes/${class_id}/members`;
    }

    checkInUser(class_id, user_id, plan_member_id) {
        const urlBase = `${this.url}/classes/${class_id}/check-in/${user_id}`;

        return plan_member_id ? `${urlBase}?plan_member_id=${plan_member_id}` : urlBase;
    }

    checkOutUser(class_id, user_id, plan_member_id) {
        const urlBase = `${this.url}/classes/${class_id}/check-out/${user_id}`;

        return plan_member_id ? `${urlBase}?plan_member_id=${plan_member_id}` : urlBase;
    }

    bookClass(classId) {
        return `${this.url}/classes/${classId}/book`;
    }

    cancelClassBook(classId) {
        return `${this.url}/classes/${classId}/cancel-book`;
    }

    // Members
    getMembers() {
        return `${this.url}/members`;
    }

    addMember() {
        return `${this.url}/members/add`;
    }

    updateMember(member_id) {
        return `${this.url}/members/${member_id}/update`;
    }

    deleteMember(member_id) {
        return `${this.url}/members/${member_id}/delete`;
    }

    addMembershipPlanToMember(id) {
        return `${this.url}/members/${id}/add-plans`;
    }

    updateMembersMebershipPlan(memberId, planMemberId) {
        return `${this.url}/members/${memberId}/plans/${planMemberId}/update`;
    }

    inviteMemberByEmail() {
        return `${this.url}/members/invite`;
    }

    getWaitingMembers() {
        return `${this.url}/members/waiting`;
    }

    getClassesForPlans() {
        return `${this.url}/plans/classes`;
    }

    assignClassesToPlans(id) {
        return `${this.url}/plans/${id}/classes`;
    }

    resendInvitation(id) {
        return `${this.url}/members/${id}/resend`;
    }

    updateStatus(id) {
        return `${this.url}/members/${id}/update-status`;
    }

    // exercises
    getAllExercises(searchFilter, offset_id) {
        let url = `${this.url}/exercises/search/all`;

        if (searchFilter && offset_id) return (url = `${url}?filter=${searchFilter}&offset_id=${offset_id}`);
        if (offset_id) return (url = `${url}?offset_id=${offset_id}`);
        if (searchFilter) return (url = `${url}?filter=${searchFilter}`);

        return url;
    }

    getRecentExercises() {
        return `${this.url}/exercises/search/recent`;
    }

    getExercisesByType(key, filter, offset_id) {
        let url = `${this.url}/exercises/search/discipline?key=${key}`;

        if (filter && offset_id) return (url = `${url}&filter=${filter}&offset_id=${offset_id}`);
        if (offset_id) return (url = `${url}&offset_id=${offset_id}`);
        if (filter) return (url = `${url}&filter=${filter}`);

        return url;
    }

    // create workout
    uploadWorkoutImage() {
        return `${this.url}/workouts/file`;
    }

    createWorkout() {
        return `${this.url}/workouts/new`;
    }

    getWorkoutOfTheDayByDateRange(start, end) {
        return `${this.url}/workouts-of-day/by-dates?start=${start}&end=${end}`;
    }

    addWorkoutOfTheDay() {
        return `${this.url}/workouts-of-day/new`;
    }

    getWorkoutOfTheWeek(mondayDate) {
        return `${this.url}/workouts-of-week/by-date?date=${mondayDate}`;
    }

    addWorkoutOfTheWeek() {
        return `${this.url}/workouts-of-week/new`;
    }

    // membership plans
    getMembershipPlans() {
        return `${this.url}/plans`;
    }

    addMembershipPlan() {
        return `${this.url}/plans/new`;
    }

    updateMembershipPlan(id) {
        return `${this.url}/plans/${id}/update`;
    }

    deleteMembershipPlan(id) {
        return `${this.url}/plans/${id}/delete`;
    }

    // users by dates
    getMembersBirthdaysByDateRange(start, end) {
        return `${this.url}/users/by-dates?start=${start}&end=${end}`;
    }

    // gymTv
    getGymTvChannels() {
        return `${this.url}/tv/channels`;
    }

    addGymTvChannel() {
        return `${this.url}/tv/channels`;
    }

    getGymTvChannelById(channelId) {
        return `${this.url}/tv/channels/${channelId}`;
    }

    updateGymTvChannelById(channelId) {
        return `${this.url}/tv/channels/${channelId}`;
    }

    deleteGymTvChannel(channelId) {
        return `${this.url}/tv/channels/${channelId}`;
    }

    addChannelItem(channelId) {
        return `${this.url}/tv/channels/${channelId}/items`;
    }

    updateChannelItem(channelId, itemId) {
        return `${this.url}/tv/channels/${channelId}/items/${itemId}`;
    }

    deleteChannelItem(channelId, itemId) {
        return `${this.url}/tv/channels/${channelId}/items/${itemId}`;
    }

    duplicateGymTvChannel(channelId) {
        return `${this.url}/tv/channels/${channelId}/duplicate`;
    }

    getGymTvClassesByRoomNumber(roomNumber) {
        return `${this.url}/classes/by-room?room=${roomNumber}`;
    }
}

class PathFactory {}

PathFactory.prototype.path = Path;

PathFactory.prototype.create = function() {
    return new this.path();
};

export const path = new PathFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/Paths/index.js